import React, { Component } from "react";
import MainDropdown from "./MainDropdown";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { SharedService } from "../SharedService/SharedService";
import KeyboardEventHandler from "react-keyboard-event-handler";

let $ = require("jquery");

class DailyQcWorklist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabs: this.props.tabs,
      isHelpScreenActive: false,
    };
  }

  componentWillMount() {
    SharedService.getDataForDQ().subscribe((response) => {
      this.setState({
        tabs: response,
      });
    });

    SharedService.getIsHelpScreenActive().subscribe((data) => {
      this.setState({ isHelpScreenActive: data.isHelpScreenActive });
    });
  }

  componentWillUnmount() {}

  componentDidMount() {
    this.focusOnRefresh();
  }

  focusOnRefresh = () => {
    // let tabCopy = JSON.parse(JSON.stringify(this.state.tabs));
    // tabCopy.forEach(state => {

    //     if (state.status === "1" && state.tabContent.activeTab) {
    //         $('#0').parent().click();
    //     }
    //     else if (state.status === "2" && state.tabContent.activeTab) {
    //         $('#1').parent().click();

    //     }
    //     else if (state.status === "3" && state.tabContent.activeTab) {

    //         $('#2').parent().click();
    //     }
    //     else if (state.status === "4" && state.tabContent.activeTab) {

    //         $('#3').parent().click();
    //     }
    //     else if (state.status === "8" && state.tabContent.activeTab) {
    //         $('#4').parent().click();
    //     }
    //     else if (state.status === "5" && state.tabContent.activeTab) {
    //         $('#5').parent().click();
    //     }
    // })
    if (sessionStorage.getItem("isActiveTab") === "1") {
      $("#0").parent().click();
      sessionStorage.setItem("isEditorReverted", "0");
    } else if (sessionStorage.getItem("isActiveTab") === "2") {
      $("#1").parent().click();
      sessionStorage.setItem("isEditorReverted", "0");
    } else if (sessionStorage.getItem("isActiveTab") === "3") {
      $("#2").parent().click();

      sessionStorage.setItem("isEditorReverted", "0");
    } else if (sessionStorage.getItem("isActiveTab") === "4") {
      $("#3").parent().click();

      sessionStorage.setItem("isEditorReverted", "0");
    } else if (sessionStorage.getItem("isActiveTab") === "8") {
      $("#4").parent().click();
    } else if (sessionStorage.getItem("isActiveTab") === "5") {
      $("#5").parent().click();

      sessionStorage.setItem("isEditorReverted", "0");
    }
  };

  focusTab = () => {
    if (!this.state.isHelpScreenActive) {
      $(".react-tabs__tab--selected").focus();
      $(".react-tabs__tab").on("keydown", function (e) {
        if (e.keyCode === 38) {
          return false;
        } else if (e.keyCode === 40) {
          return false;
        }
      });
    }
  };

  render() {
    if (sessionStorage.getItem("firstTab") === "0") {
      this.focusOnRefresh();
    }

    return (
      <div>
        <KeyboardEventHandler
          handleKeys={["shift+t"]}
          handleFocusableElements={true}
          onKeyEvent={(key, e) => this.focusTab()}
        />
        <div>
          <div className="heading-bottom-line ml-3 pt-4 start complete">
            <h1 className="txt-violet fw-normal fs18">Daily QC Worklist</h1>
          </div>
          <div className="programs pb-4">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12 pl-0 pr-0">
                  <Tabs>
                    <TabList>
                      {this.state.tabs.map((tab, i) => (
                        <Tab key={i}>
                          <div id={i}>{tab.tabName}</div>
                        </Tab>
                      ))}
                    </TabList>
                    {this.state.tabs.map((tab, i) => (
                      <TabPanel key={i}>
                        <MainDropdown
                          data={tab}
                          applyFilter={this.applyFilterHandler}
                          applyReset={this.applyResetHandler}
                          populateEditor={this.populateEditorHandler}
                          populateSubGenre={this.populateSubGenreHandler}
                          selectMultipleOptionTest={this.EditorHandler}
                          airingreset={this.airingDataReset}
                          EditorRevertedFunc={this.EditorRevertedHandler}
                          populateImgSize={this.populateImgSizeHandler}
                        />
                      </TabPanel>
                    ))}
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  applyFilterHandler = (data) => {
    data.action = "applyfilter";
    SharedService.setFilterData(data);
  };

  EditorHandler = (value, name) => {
    name.action = "Editor";
    name.worklisttype = "2";
    name.status = value.status;
    SharedService.setFilterData(name);
  };

  applyResetHandler = (data) => {
    data.action = "applyReset";
    SharedService.setFilterData(data);
  };

  airingDataReset = (data) => {
    data.action = "AiringDateReset";
    SharedService.setFilterData(data);
  };

  populateEditorHandler = (data) => {
    data.action = "populateEditor";
    data.worklisttype = "2";
    SharedService.setFilterData(data);
  };

  populateSubGenreHandler = (data) => {
    data.action = "populateSubGenre";
    data.worklisttype = "2";
    SharedService.setFilterData(data);
  };

  populateImgSizeHandler = (data) => {
    data.action = "populateImgSize";
    data.worklisttype = "2";
    SharedService.setFilterData(data);
  };

  EditorRevertedHandler = (data) => {
    data.action = "EditorReverted";
    SharedService.setFilterData(data);
  };
}
export default DailyQcWorklist;
